module.exports = __webpack_public_path__ + "static/media/mastercard.af05450d.png";